import Vue from 'vue'
import { CombinedVueInstance } from 'vue/types/vue'
import Toast from '../components/Toast/plugin.vue'

const defaultOptions = {
  duration: 2000,
  type: 'text',
}

const VueToast = Vue.extend(Toast)
let toast: CombinedVueInstance<Toast, any, any, any, any, any>
window.$toasted = {
  show(
    text: string,
    options?: {
      duration?: number
    },
  ) {
    if (!toast) {
      const ele = document.querySelector('body')
      toast = new VueToast({
        propsData: {
          defaultOptions: { ...defaultOptions },
        },
      })
      toast.$mount()
      toast.show(text, options)
      ele && ele.appendChild(toast.$el)
    } else {
      toast.show(text, options)
    }
  },
  ...toast,
}

export default {
  install(app: typeof Vue) {
    app.prototype.$toasted = window.$toasted
  },
}
